import cx from "classnames";
import { settingsMessages } from "common/MapV2/controls/SettingsMenu";
import { useFormatMessage } from "lib/localization";
import React from "react";
import styles from "./BikeLayerToggle.scss";

export const BikeLayerToggle = ({ bikeLayer, toggle }) => {
  const fm = useFormatMessage();

  return (
    <div className={styles.bikeContainer}>
      <button onClick={toggle} className={cx(styles.BikeLayerToggle, bikeLayer && styles.active)}>
        {fm(settingsMessages.bikePaths)}
      </button>
    </div>
  );
};
